import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { List,Icon,Form} from 'antd';
import { Link } from 'react-router-dom';
class AppCenter extends React.Component {
	HomeLink=[
		{
	    name: '我的薪资',
      enname: 'My Salary',
	    icon: 'credit-card',
	    path: '/employee/my-salary'
		},
		 {
	    name: '通讯录',
      enname: 'Contacts',
	    icon: 'contacts',
	    path: '/employee/address-list'
	  }, {
	    name: '行事历',
      enname: 'Calendar',
	    icon: 'calendar',
	    path: '/attendance/company-calendar'
	  }]
	render() {
		return (
			<div className="app-module-item">
				<div className="Attendanceholiday">应用中心 Application Center</div>
				<List
                  grid={{ gutter: 16, column: 6 }}
                  dataSource={this.HomeLink}
                  renderItem={item => (
                    <List.Item> 
                      <Link to={item.path}>
                        <div className="mobileMenu">
                          <div className="mobileMenuIcon"><Icon type={item.icon}/></div>
                          <div className="mobileMenuName">{item.name}<br/>{item.enname}</div>
                        </div>
                      </Link>
                    </List.Item>
                  )}
                />
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		
	}
}

const mapDispatchToProps = {
}

AppCenter = Form.create()(AppCenter);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AppCenter));


// WEBPACK FOOTER //
// ./src/routes/Employee/AppCenter.js